<template>
  <input-base ref="input"
              :type="type"
              :value="value"
              :placeholder="placeholder"
              :help="help"
              :error="error"
              :transparent="transparent"
              @input="inputted"
              @change="changed"
              @blur="blurred"
              @focus="focused"
              @click="clicked"></input-base>
</template>

<style lang="stylus" scoped>
</style>

<script>
  import InputBase from './InputBase.vue'
  export default {
    components: {
      InputBase
    },
    props: {
      transparent: Boolean,
      error: String,
      help: String,
      placeholder: String,
      value: String,
      type: String
    },
    methods: {
      inputted (e) {
        this.$emit('input', e)
      },
      changed (e) {
        this.$emit('change', e)
      },
      blurred (e) {
        this.$emit('blur', e)
      },
      focused (e) {
        this.$emit('focus', e)
      },
      clicked (e) {
        this.$emit('click', e)
      },
      focus () {
        this.$refs.input.focus()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InputAlignLeft.vue?6d315dda